import { render, staticRenderFns } from "./pointsDetail.vue?vue&type=template&id=2174260c&scoped=true&"
import script from "./pointsDetail.vue?vue&type=script&lang=js&"
export * from "./pointsDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointsDetail.vue?vue&type=style&index=0&id=2174260c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174260c",
  null
  
)

export default component.exports